import { styled } from '../../Styles/stitches.config'

export const StyledTextWrapper = styled('div', {
    whiteSpace: 'pre-line',
    wordWrap: 'break-word',
})
